export const getModalDetails = (state, id) => state.modal[id];